import React from 'react';
import { SocialSharePlatformProvider } from '../SocialSharePlatformContext';
import { SocialSharePlatformProviderProps } from '../types';
import useYouTubeSocialShare from './useYouTubeSocialShare';

const YouTubeSocialShareProvider: React.FC<SocialSharePlatformProviderProps> = ({
  children,
}) => {
  const platformData = useYouTubeSocialShare();

  return (
    <SocialSharePlatformProvider value={platformData}>
      {children}
    </SocialSharePlatformProvider>
  );
};

export default YouTubeSocialShareProvider;
